import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Block.module.scss'

/**
 * The `Block`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Block = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, lineItemStyles.block, styles.block]),
    [className]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
})

// Display name
Block.displayName = 'Block'

/** @type {object} */
Block.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

/** @type {object} */
Block.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Block)
